<style type="text/css">

  .absolute-divs {
  margin: 0;
  padding: 0;
  z-index: 2;
  position: absolute;
  transform:translate(-50%, 0);
  width: 71.2%;
  left: 50%;
}
.play-container {
height: 9.83%;
bottom: 40.16%;
-webkit-transition: opacity 300ms ease-in-out;
-moz-transition: opacity 300ms ease-in-out;
-o-transition: opacity 300ms ease-in-out;
transition: opacity 300ms ease-in-out;
}
.svg-bg {
width: auto;
height: auto;
z-index: 2;
background-size: contain;
background-repeat: no-repeat;
transition: 200ms;
transition-timing-function: ease-in-out;
-webkit-transition: 200ms;
-webkit-transition-timing-function: ease-in-out;
cursor: pointer;
display: block;
margin: 0 auto;
}
.svg-bg.play-button {
width: 9.67%;
height: 100%;
background-image: url('/assets/img/play-button.svg');
}
.svg-bg.play-button:hover {
background-image: url('/assets/img/play-button-color.svg');
}
</style>
<div class="absolute-divs play-container">
  @if (!underPlay && currentTime != duration && shouldShowPlay) {
    <button data-testid="rating-play" aria-label="Play" type="button" class="btn btn-link svg-bg play-button" (click)="onPlay()"></button>
  }
</div>
